import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useUser } from "~/Context/userContext";
import { getGenreIsFavorite, getGenreSetFavorite } from "~/api/getGenre";

import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";

import styled from "styled-components";

export const Wrapper = styled.section`
  font-size: 16px;
  margin: 4px 0 20px 0;
  div {
    background-color: #efefef;
    border-radius: 6px;
    overflow: auto;
    padding: 2px 5px;
    line-height: 36px;
    max-width: 320px;
    margin: 0 auto;
  }
  button {
    border: 0;
    padding: 4px 8px;
    margin-right: 8px;
    background-color: transparent;
  }
  .star-icon {
    margin-top: 2px;
    margin-right: 7px;
    font-size: 20px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const GenreAddFavorite = (props) => {
  const { genreId } = props;
  const { state: userState, dispatch } = useUser();

  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    getGenreIsFavorite(axios, genreId).then((result) => setIsFavorite(result.data.liked));
  }, []);

  const setFavorite = async () => {
    if (!userState.loggedin) {
      localStorage.setItem("login_genre_fav", genreId);
      dispatch({ type: "signin_open" });
      // faked since we cant set these values after login/register
      setIsFavorite(true);
      return;
    }
    getGenreSetFavorite(axios, genreId).then((result) => setIsFavorite(!isFavorite));
  };

  if (!genreId) return null;

  return (
    <span>
      <Wrapper>
        <div onClick={setFavorite}>
          <button>
            <FontAwesomeIcon className="star-icon" icon={isFavorite ? faStar : faStarOutline} />
          </button>
          {isFavorite ? `Remove from favorites` : `Add Genre to favorites`}
        </div>
      </Wrapper>
    </span>
  );
};

GenreAddFavorite.propTypes = {
  genreId: PropTypes.number,
};

export default GenreAddFavorite;
